
import { Common, ApiBind } from './common.model';

export class DeliverySetDeviceModelGroup extends Common {
  @ApiBind({ column: 'device_model_group_id' })
  id: number;
}
